import { Flame } from 'lucide-react';

const DRAGON_IMAGE = "https://static.prod-images.emergentagent.com/jobs/2e421070-bee1-421e-b8d4-a5b3287448e7/images/d50153520bf6491265930045a154560b5b35949e0f1beea5ecc0cf5f92e4139c.png";

export const HeroBanner = ({ settings }) => {
  const s = settings || {};
  const bgImg = s.hero_bg_url;              // ambient background behind hero
  const dragonImg = s.hero_image_url || DRAGON_IMAGE;
  const title = s.title || 'RDPT+';
  const subtitle = s.subtitle || 'PLUS';
  const tagline = s.tagline || 'Daily Tournament Schedule';
  const dateRange = s.date_range || 'April 13 - 18, 2026';
  const brandName = s.brand_name || 'RDPT Plus';

  // Header banner removed — dragon mascot on left + title stack on right.
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden"
      style={{ background: '#080404' }}
    >
      <div className="absolute top-0 left-1/4 w-[600px] h-[400px] rounded-full opacity-[0.07]" style={{ background: 'radial-gradient(circle, #b91c1c 0%, transparent 70%)' }} />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[300px] rounded-full opacity-[0.05]" style={{ background: 'radial-gradient(circle, #d4af37 0%, transparent 70%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-center min-h-[380px] sm:min-h-[420px]">
          <div className="relative flex items-center justify-center lg:justify-start py-8 lg:py-0">
            <div className="relative w-full max-w-[620px] h-[280px] sm:h-[320px] overflow-hidden rounded-lg"
              style={{
                backgroundImage: `url(${dragonImg})`,
                backgroundSize: '130% auto',
                backgroundPosition: 'center 35%',
                backgroundRepeat: 'no-repeat',
                filter: 'brightness(0.95) contrast(1.1)',
              }}
            >
              <div className="absolute inset-0" style={{ boxShadow: 'inset 0 0 80px 50px #080404' }} />
            </div>
          </div>

          <div className="text-center lg:text-right pb-10 lg:pb-0">
            <div className="flex items-center justify-center lg:justify-end gap-3 mb-5">
              <div className="w-11 h-11 rounded-full border-2 border-secondary-main/60 flex items-center justify-center bg-secondary-main/10">
                <Flame className="w-5 h-5 text-red-500" />
              </div>
              <span className="font-heading text-[11px] tracking-[0.35em] uppercase text-red-400/80">{brandName}</span>
            </div>

            <h1 data-testid="hero-title" className="font-heading text-6xl sm:text-7xl lg:text-8xl font-bold tracking-[-0.04em] uppercase leading-[0.85]">
              <span className="text-white">{title.replace(/[+*]$/, '')}</span>
              <span className="text-primary-main">{title.match(/[+*]$/)?.[0] || ''}</span>
            </h1>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-white/90 mt-1 leading-[0.9]">
              {subtitle}
            </h2>

            <div className="mt-8">
              <div className="inline-flex items-center gap-3">
                <div className="h-px w-12 bg-primary-main/40" />
                <p className="font-heading text-base sm:text-lg tracking-[0.2em] uppercase text-primary-main">{tagline}</p>
                <div className="h-px w-12 bg-primary-main/40" />
              </div>
              <p className="font-body text-xs text-white/30 mt-3 tracking-wider">{dateRange}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="h-[2px] w-full" style={{ background: 'linear-gradient(to right, transparent, #b91c1c, #d4af37, #b91c1c, transparent)' }} />
    </section>
  );
};
